import { MeasuringEquipmentsControlName, MeasuringEquipmentTableRow } from '../types/measuring-equipments';
import moment from 'moment';

export class MeasurementEquipmentUtilities {
    public static getDateUsed(row: MeasuringEquipmentTableRow): moment.Moment {
        const dateUsedColumn = row.columns.find(
            (col) => col.columnName === MeasuringEquipmentsControlName.DateUsed,
        )?.value;

        return row.columns.length > 3 ? moment(dateUsedColumn) : moment().startOf('day');
    }
}
